package com.ijoin.data.repository

import com.ijoin.data.api.BillingApi
import com.ijoin.data.model.BillingOverview
import com.ijoin.data.model.MoneyAmount
import com.ijoin.data.model.PayoutMethod
import com.ijoin.data.model.PayoutRequest

class BillingRepository(
    private val billingApi: BillingApi = BillingApi()
) {
    suspend fun loadBilling(
        filter: BillingFilter
    ): Result<BillingOverview> = billingApi.getOverview(filter)

    suspend fun requestWithdrawal(
        amount: MoneyAmount,
        method: PayoutMethod,
        details: Map<String, String>,
        note: String? = null
    ): Result<PayoutRequest> = billingApi.requestWithdrawal(amount, method, details, note)
}

enum class BillingFilter {
    THIS_WEEK,
    THIS_MONTH,
    NINETY_DAYS
}
